// node-modules
import PubSub from 'pubsub-js';

// constants
import { PRELOADER_END } from '@/components/preloader';
import { SELECTORS } from '@/scripts/constants';

// component
import Component from '@/components/Component';

// other
import { isEdge } from '@/scripts/helper';

// assets
import './sliders.scss';

class SwiperSlider extends Component {
  constructor(props) {
    super(props);

    const swiperConfig = {
      slidesPerView: 3,
      spaceBetween: 20,
      keyboard: {
        onlyInViewport: true,
      },
      navigation: {
        nextEl: '[data-role="swiper-button-next"]',
        prevEl: '[data-role="swiper-button-prev"]',
      },
      speed: 700,
    };

    this.setProps({
      swiperConfig,
    });

    this.swiper = null;
  }

  init() {
    this.swiper = new Swiper(this._element, this._props.swiperConfig);
  }
}

export class NewsSlider extends SwiperSlider {
  constructor(props) {
    super(props);
    this.setProps({
      swiperConfig: {
        ...this._props.swiperConfig,
        spaceBetween: 25,
        breakpoints: {
          1023: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          639: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
        },
      },
    });
  }
}

export class OtherItemsSlider extends SwiperSlider {
  constructor(props) {
    super(props);
    this.setProps({
      swiperConfig: {
        ...this._props.swiperConfig,
        slidesPerView: 5,
        spaceBetween: 30,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        loop: true,
        breakpoints: {
          1023: {
            slidesPerView: 3,
          },
          639: {
            slidesPerView: 1,
          },

        },
      },
    });
  }
}

export class HistorySlider extends SwiperSlider {
  constructor(props) {
    super(props);
    this.setProps({
      swiperConfig: {
        ...this._props.swiperConfig,
        slidesPerView: 3,
        spaceBetween: 30,
        breakpoints: {
          1024: {
            slidesPerView: 2,
          },
          639: {
            slidesPerView: 1,
          },
        },
      },
    });
  }
}

export const HERO_SLIDE_CHANGE = 'HERO:SLIDE_CHANGE';
export const HERO_AUTOPLAY_STOP = 'HERO:AUTOPLAY_STOP';
export const HERO_AUTOPLAY_START = 'HERO:AUTOPLAY_START';

export class HeroSlider extends SwiperSlider {
  constructor(props) {
    super(props);
    this.setProps({
      swiperConfig: {
        ...this._props.swiperConfig,
        init: false,
        slidesPerView: 1,
        simulateTouch: false,
        spaceBetween: 0,
        speed: 500,
        keyboard: false,
        initialSlide: 1,
        effect: isEdge() ? null : 'fade',
        slideToClickedSlide: true,
      },
    });
  }

  _onSlideChange() {
    if (isEdge()) {
      return;
    }
    const {
      activeIndex, slides,
    } = this.swiper;

    Array.from(slides).forEach((slide, i) => {
      const distance = i - activeIndex;

      PubSub.publish(HERO_SLIDE_CHANGE);
      $(slide).find('.card').css({
        transform: `
          translate(${distance * 50}%, ${activeIndex === i ? 0 : 100}px)
          scale(${i === activeIndex ? 1 : 0.75})
      `,
      });
      slide.classList.toggle('is-prev', i < activeIndex);
      slide.classList.toggle('is-next', i > activeIndex);
    });
  }

  _setupAutoplay() {
    let interval = null;
    let current = this.swiper.activeIndex;
    let direction = 1;

    PubSub.subscribe(HERO_SLIDE_CHANGE, () => {
      current = this.swiper.activeIndex;
    });
    PubSub.subscribe(HERO_AUTOPLAY_START, () => {
      clearInterval(interval);
      interval = setInterval(() => {
        const next = current + direction;
        if ((next === this.swiper.slides.length - 1) || next === 0) {
          direction *= -1;
        }
        this.swiper.slideTo(next);
      }, 7000);
    });
    PubSub.subscribe(HERO_AUTOPLAY_STOP, () => {
      clearInterval(interval);
    });

    PubSub.subscribe(PRELOADER_END, () => {

    });
  }

  _setupClickedSlide() {
    const { slides } = this.swiper;
    Array.from(slides).forEach((slide, i) => {
      const trigger = slide.querySelector('[data-role="trigger"]');
      trigger.addEventListener('click', () => {
        this.swiper.slideTo(i);
      });
    });
  }

  _setupEvents() {
    PubSub.subscribe(HERO_AUTOPLAY_STOP, () => {
      const { slides } = this.swiper;
      console.log('hero autoplay stop');
      Array.from(slides).forEach((slide) => {
        slide.classList.add(SELECTORS.hidden);
      });
    });

    PubSub.subscribe(HERO_AUTOPLAY_START, () => {
      const { slides } = this.swiper;
      console.log('hero autoplay start');
      Array.from(slides).forEach((slide) => {
        slide.classList.remove(SELECTORS.hidden);
      });
    });

    this.swiper.on('slideChange', () => {
      this._onSlideChange();
    });

    PubSub.subscribe(PRELOADER_END, () => {
      this._onSlideChange();
      this._setupAutoplay();
      setTimeout(() => {
        this.swiper.init();
        this._setupClickedSlide();
        PubSub.publish(HERO_AUTOPLAY_START);
      }, 200);
    });
  }

  init() {
    super.init();
    this._setupEvents();
  }
}
